// extracted by mini-css-extract-plugin
export var closeButton = "_of-2";
export var closeButtonIcon = "_of-3";
export var lightboxContent = "_of-1";
export var lightboxOverlay = "_of-0";